import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

import Landing from "@/pages/Landing";
import HowItWorks from "@/pages/HowItWorks";
import Explore from "@/pages/Explore";
import ProjectDetail from "@/pages/ProjectDetail";
import BriefPublic from "@/pages/BriefPublic";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import ProjectsList from "@/pages/creator/ProjectsList";
import ProjectEditor from "@/pages/creator/ProjectEditor";
import CreatorMatches from "@/pages/creator/CreatorMatches";
import CreatorProfile from "@/pages/creator/CreatorProfile";
import SocialProof from "@/pages/creator/SocialProof";
import SponsorBriefs from "@/pages/sponsor/SponsorBriefs";
import BriefEditor from "@/pages/sponsor/BriefEditor";
import SponsorMatches from "@/pages/sponsor/SponsorMatches";
import SponsorProfile from "@/pages/sponsor/SponsorProfile";
import SponsorBrands from "@/pages/sponsor/SponsorBrands";
import Messages from "@/pages/Messages";
import Proposals from "@/pages/Proposals";
import SavedItems from "@/pages/SavedItems";
import AdminPanel from "@/pages/AdminPanel";
import Analytics from "@/pages/Analytics";
import Verification from "@/pages/Verification";
import CulturalFunds from "@/pages/CulturalFunds";
import RoomsList from "@/pages/RoomsList";
import RoomDetail from "@/pages/RoomDetail";
import AdminVerifications from "@/pages/AdminVerifications";
import Certificates from "@/pages/Certificates";
import Vitrina from "@/pages/Vitrina";
import ScriptAnalysis from "@/pages/ScriptAnalysis";

import { ProtectedRoute } from "@/lib/ProtectedRoute";

function AppRouter() {
  const location = useLocation();
  if (location.hash && location.hash.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/como-funciona" element={<HowItWorks />} />
      <Route path="/explorar" element={<Explore />} />
      <Route path="/vitrina" element={<Vitrina />} />
      <Route path="/proyecto/:id" element={<ProjectDetail />} />
      <Route path="/brief/:id" element={<BriefPublic />} />
      <Route path="/login" element={<Login />} />
      <Route path="/registro" element={<Register />} />

      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/dashboard/proyectos" element={<ProtectedRoute roles={["creator", "admin"]}><ProjectsList /></ProtectedRoute>} />
      <Route path="/dashboard/proyectos/nuevo" element={<ProtectedRoute roles={["creator", "admin"]}><ProjectEditor /></ProtectedRoute>} />
      <Route path="/dashboard/proyectos/:id" element={<ProtectedRoute roles={["creator", "admin"]}><ProjectEditor /></ProtectedRoute>} />
      <Route path="/dashboard/proyectos/:id/prueba-social" element={<ProtectedRoute roles={["creator"]}><SocialProof /></ProtectedRoute>} />
      <Route path="/dashboard/proyectos/:id/analisis-ia" element={<ProtectedRoute roles={["creator"]}><ScriptAnalysis /></ProtectedRoute>} />
      <Route path="/dashboard/coincidencias" element={<ProtectedRoute roles={["creator"]}><CreatorMatches /></ProtectedRoute>} />
      <Route path="/dashboard/perfil-creador" element={<ProtectedRoute roles={["creator", "admin"]}><CreatorProfile /></ProtectedRoute>} />

      <Route path="/dashboard/briefs" element={<ProtectedRoute roles={["sponsor", "admin"]}><SponsorBriefs /></ProtectedRoute>} />
      <Route path="/dashboard/briefs/nuevo" element={<ProtectedRoute roles={["sponsor", "admin"]}><BriefEditor /></ProtectedRoute>} />
      <Route path="/dashboard/briefs/:id" element={<ProtectedRoute roles={["sponsor", "admin"]}><BriefEditor /></ProtectedRoute>} />
      <Route path="/dashboard/marcas" element={<ProtectedRoute roles={["sponsor", "admin"]}><SponsorBrands /></ProtectedRoute>} />
      <Route path="/dashboard/recomendaciones" element={<ProtectedRoute roles={["sponsor"]}><SponsorMatches /></ProtectedRoute>} />
      <Route path="/dashboard/perfil-sponsor" element={<ProtectedRoute roles={["sponsor", "admin"]}><SponsorProfile /></ProtectedRoute>} />

      <Route path="/dashboard/mensajes" element={<ProtectedRoute><Messages /></ProtectedRoute>} />
      <Route path="/dashboard/propuestas" element={<ProtectedRoute><Proposals /></ProtectedRoute>} />
      <Route path="/dashboard/guardados" element={<ProtectedRoute><SavedItems /></ProtectedRoute>} />
      <Route path="/dashboard/analitica" element={<ProtectedRoute roles={["creator", "sponsor"]}><Analytics /></ProtectedRoute>} />
      <Route path="/dashboard/verificacion" element={<ProtectedRoute><Verification /></ProtectedRoute>} />
      <Route path="/dashboard/convocatorias" element={<ProtectedRoute><CulturalFunds /></ProtectedRoute>} />
      <Route path="/dashboard/negociaciones" element={<ProtectedRoute><RoomsList /></ProtectedRoute>} />
      <Route path="/dashboard/negociaciones/:id" element={<ProtectedRoute><RoomDetail /></ProtectedRoute>} />
      <Route path="/dashboard/certificados" element={<ProtectedRoute><Certificates /></ProtectedRoute>} />

      <Route path="/dashboard/admin" element={<ProtectedRoute roles={["admin"]}><AdminPanel /></ProtectedRoute>} />
      <Route path="/dashboard/admin/verificaciones" element={<ProtectedRoute roles={["admin"]}><AdminVerifications /></ProtectedRoute>} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppRouter />
    </BrowserRouter>
  );
}
